import { Injectable } from '@angular/core';

export class ArrearsTransactionField {

  constructor(label: string, fieldName: string) {
    this.label = label;
    this.fieldName = fieldName;
  }

  label: string;
  fieldName: string;
}

@Injectable()
export class ArrearsTransactionFields {
  fields: Map<string, ArrearsTransactionField>;

  get allFields(): ArrearsTransactionField[] {
    return Array.from(this.fields.values());
  }

  get age(): ArrearsTransactionField {
    return this.fields.get(ArrearsFieldLabels.AGE_ENTITY);
  }

  get tenant(): ArrearsTransactionField {
    return this.fields.get(ArrearsFieldLabels.TENANT_ENTITY);
  }

  get debtor(): ArrearsTransactionField {
    return this.fields.get(ArrearsFieldLabels.DEBTOR_ENTITY);
  }

  get subLedger(): ArrearsTransactionField {
    return this.fields.get(ArrearsFieldLabels.SUBLEDGER);
  }

  get propertyType(): ArrearsTransactionField {
    return this.fields.get(ArrearsFieldLabels.PROPERTY_TYPE_ENTITY);
  }

  get location(): ArrearsTransactionField {
    return this.fields.get(ArrearsFieldLabels.LOCATION_ENTITY);
  }

  get paymentPlan(): ArrearsTransactionField {
    return this.fields.get(ArrearsFieldLabels.PAYMENT_PLAN_ENTITY);
  }

  get propertyGroup(): ArrearsTransactionField {
    return this.fields.get(ArrearsFieldLabels.PROPERTY_GROUP_ENTITY);
  }

  get property(): ArrearsTransactionField {
    return this.fields.get(ArrearsFieldLabels.PROPERTY_ENTITY);
  }

  get groupFields(): ArrearsTransactionField[] {
    return [
      this.age,
      this.property,
      this.tenant,
      this.debtor,
      this.propertyType,
      this.propertyGroup,
      this.location,
      this.paymentPlan,
      this.subLedger
    ];
  }

  get propertyGroupFields(): ArrearsTransactionField[] {
    return [
      this.age,
      this.property,
      this.tenant,
      this.debtor,
      this.paymentPlan
    ];
  }

  constructor() {
    this.fields = defaultArrearsFieldsMap();
  }

}


class ArrearsFieldNames {
  static DAYS_30: string = 'Days30';
  static DAYS_60: string = 'Days60';
  static DAYS_120: string = 'Days120';
  static DAYS_90: string = 'Days90';
  static DAYS_120_PLUS: string = 'Days120Plus';
  static SUBLEDGER: string = 'SystemSubLedger';
  static AGE_ENTITY: string = 'SystemAge';
  static TENANT_ENTITY: string = 'SystemTenant';
  static DEBTOR_ENTITY: string = 'SystemDebtor';
  static PROPERTY_TYPE_ENTITY: string = 'SystemPropertyType';
  static PROPERTY_GROUP_ENTITY: string = 'SystemPropertyGroup';
  static LOCATION_ENTITY: string = 'SystemLocation';
  static PAYMENT_PLAN_ENTITY: string = 'SystemPaymentPlan';
  static PROPERTY_ENTITY: string = 'SystemProperty';
}

class ArrearsFieldLabels {
  static DAYS_30: string = '0-30';
  static DAYS_60: string = '30-60';
  static DAYS_90: string = '60-90';
  static DAYS_120: string = '90-120';
  static DAYS_120_PLUS: string = '120+';
  static AGE_ENTITY: string = 'Age';
  static TENANT_ENTITY: string = 'Tenant';
  static DEBTOR_ENTITY: string = 'Debtor';
  static SUBLEDGER: string = 'Sub Ledger';
  static PROPERTY_TYPE_ENTITY: string = 'Property Type';
  static PROPERTY_GROUP_ENTITY: string = 'Property Group';
  static LOCATION_ENTITY: string = 'Property Location';
  static PAYMENT_PLAN_ENTITY: string = 'Payment Plan';
  static PROPERTY_ENTITY: string = 'Property';
}


const defaultArrearsFieldsMap = () => {
  const result = new Map<string, ArrearsTransactionField>();
  result.set(ArrearsFieldLabels.AGE_ENTITY, new ArrearsTransactionField(ArrearsFieldLabels.AGE_ENTITY, ArrearsFieldNames.AGE_ENTITY));
  result.set(ArrearsFieldLabels.TENANT_ENTITY, new ArrearsTransactionField(ArrearsFieldLabels.TENANT_ENTITY, ArrearsFieldNames.TENANT_ENTITY));
  result.set(ArrearsFieldLabels.DEBTOR_ENTITY, new ArrearsTransactionField(ArrearsFieldLabels.DEBTOR_ENTITY, ArrearsFieldNames.DEBTOR_ENTITY));
  result.set(ArrearsFieldLabels.SUBLEDGER, new ArrearsTransactionField(ArrearsFieldLabels.SUBLEDGER, ArrearsFieldNames.SUBLEDGER));
  result.set(ArrearsFieldLabels.PROPERTY_TYPE_ENTITY, new ArrearsTransactionField(ArrearsFieldLabels.PROPERTY_TYPE_ENTITY, ArrearsFieldNames.PROPERTY_TYPE_ENTITY));
  result.set(ArrearsFieldLabels.PROPERTY_GROUP_ENTITY, new ArrearsTransactionField(ArrearsFieldLabels.PROPERTY_GROUP_ENTITY, ArrearsFieldNames.PROPERTY_GROUP_ENTITY));
  result.set(ArrearsFieldLabels.LOCATION_ENTITY, new ArrearsTransactionField(ArrearsFieldLabels.LOCATION_ENTITY, ArrearsFieldNames.LOCATION_ENTITY));
  result.set(ArrearsFieldLabels.PAYMENT_PLAN_ENTITY, new ArrearsTransactionField(ArrearsFieldLabels.PAYMENT_PLAN_ENTITY, ArrearsFieldNames.PAYMENT_PLAN_ENTITY));
  result.set(ArrearsFieldLabels.PROPERTY_ENTITY, new ArrearsTransactionField(ArrearsFieldLabels.PROPERTY_ENTITY, ArrearsFieldNames.PROPERTY_ENTITY));
  return result;
};


